import * as SIPJS from '@livecaller/sip.js'

export default {
    ua: {
        transportOptions: {
            traceSip: false,
        },
        log: {
            builtinEnabled: true,
            level: 'warn',
        },
        register: false,
        userAgentString: 'LiveCaller WebPhone-v1.0',
        stunServers: [],
        rel100: SIPJS.C.supported.SUPPORTED,
        sessionDescriptionHandlerFactoryOptions: {
            constraints: {
                audio: true,
                video: false,
            },
            peerConnectionOptions: {
                rtcConfiguration: {
                    iceServers: [],
                },
                iceCheckingTimeout: 1000,
            },
        },
    },

}
